import React from 'react'
import ValidateLiveness from './validate-liveness'

const ValidateLivenessWithoutKyc = () => <ValidateLiveness kyc={false} />

export default ValidateLivenessWithoutKyc
